import Modal from 'react-modal';
import ButtonGroup from '../uiControls/ButtonGroup';
import { useContext, useEffect, useRef, useState } from 'react';
import ApplicationContext from '../ApplicationContext';
import useGlobalOkDialog from '../hooks/useGlobalOkDialog';
import constants from '../constants';
import { getRecogConfirmMsg, getRecogSQLInfos } from '../fms.data/modules/FmsModFunc';
import { compareIso, formatDate, getDate } from '../dateUtils';
import React from 'react';
import Date from '../ui/Date';
import { selectInput } from '../util/inputUtils';
import NoticeWarningIcon from '../img/notice_warning.svg';

const ModalOverlayStyle: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.55)',
    zIndex: 888888
};

const ModalDialogContentStyle: React.CSSProperties = {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    border: '1px solid',
    borderRadius: '0px',
    borderColor: '#00F',
    zIndex: 10000,
    paddingLeft: '40px',
    paddingRight: '40px'
};

function RecogModal({
    mTbId = 0,
    isSet = false,
    mTbName = '',
    onCancel = () => { },
    reloadData = () => { },
}: {
    mTbId: number,
    isSet: boolean,
    mTbName: string,
    onCancel: () => void,
    reloadData: (recogDate: string) => void,
}) {
    const appContext = useContext(ApplicationContext);
    const [showGlobalOkDialog] = useGlobalOkDialog();

    const [estRecogDate, setEstRecogDate] = useState('');
    const [firstAcctDate, setFirstAcctDate] = useState('');
    const [recogDate, setRecogDate] = useState('');
    const beforeClosing = useRef(false);

    useEffect(() => {
        initialize();
        setTimeout(() => {
            const recogDateField = document.getElementById('recogmodal-recogdate');
            if (recogDateField) selectInput(recogDateField as HTMLInputElement);
        }, 10);
    }, []);

    async function initialize() {
        let apiResult = await appContext.api.getEstFinalizeDateEx(mTbName, mTbId);
        setFirstAcctDate(getDate(apiResult?.result?.item1) ?? "") // FirstAcctDate
        setRecogDate(getDate(apiResult?.result?.item2) ?? "");  // ReturnDate
        setEstRecogDate(getDate(apiResult?.result?.item2) ?? "");  // EstRecogDate
        beforeClosing.current = apiResult?.result?.item3;
    }

    async function recognize() {
        if (compareIso(recogDate, firstAcctDate) < 0) {
            await showGlobalOkDialog(<p>(can change the date from {formatDate(firstAcctDate)})</p>, false, null, 'warning');
            return;
        }

        const result = getRecogConfirmMsg(estRecogDate, beforeClosing.current, isSet);
        if (result.errorMsg) {
            await showGlobalOkDialog(<p>{result.errorMsg}</p>, false, null, 'warning');
            onCancel();
            return;
        }

        let apiResult = await appContext.api.checkFinalizeData(mTbName, mTbId);
        let msg = apiResult?.result;
        if (!apiResult || msg) {
            await showGlobalOkDialog(<p>{msg ?? constants.LOAD_ERROR_MESSAGE}</p>, false, null, 'warning');
            onCancel();
            return;
        }

        const sqlInfos = getRecogSQLInfos(mTbName, mTbId, recogDate, appContext.user?.id ?? "", isSet);
        apiResult = await appContext.api.saveRecognizeData(sqlInfos);
        if (!apiResult || !apiResult.success) {
            msg = constants.SAVE_ERROR_MESSAGE;
            await showGlobalOkDialog(<p>{msg}</p>);
            onCancel();
            return;
        }
        onCancel();
        reloadData(recogDate);
    }

    const alignMargin = '42px';

    return (
        <Modal
            isOpen={true}
            shouldCloseOnOverlayClick={false}
            shouldCloseOnEsc={false}
            contentLabel=""
            style={{
                overlay: ModalOverlayStyle,
                content: ModalDialogContentStyle
            }}
        >
            {isSet ?
                <div>
                    <img src={NoticeWarningIcon} style={{ height: 32, width: 32, marginRight:'10px' }} alt="" />
                    <span style={{ fontSize: '15px' }}>This Action will recognize Sales, Cost in B/L on recog date.</span><br></br>
                    <div style={{ display: 'flex', marginLeft: '200px' }}>
                        <span  style={{ fontSize: '17px', textDecoration: 'underline' }}>Recog Date</span>
                        <div style={{ width: '70px', marginLeft: '20px', marginRight: '20px' }}>
                            <Date dateId='recogmodal-recogdate' onChange={(date) => { setRecogDate(date ?? '') }} value={recogDate}></Date>
                        </div>
                    </div>
                    <div style={{ display: 'flex', marginLeft: alignMargin }}>
                        <span style={{ fontSize: '15px' }}>(can change Recog Date if Change Date is after Bill Start Date [{formatDate(firstAcctDate)}])</span>
                    </div>
                    <br></br>
                    <div style={{ display: 'flex', marginLeft: '100px' }}>
                        <span style={{ fontSize: '19px', paddingTop: '6px', marginRight: '30px', textDecoration: 'underline' }}>Confirm to Recognize ?</span>
                        <ButtonGroup
                            customClass="ifms-dialog-button ifms-dialog-button-yesorno"
                            buttons={['Yes', 'No']}
                            onButton={b => {
                                if (b === 'Yes') recognize();
                                else onCancel();
                            }}
                            defaultFocusIndex={-1}
                            addOr={true}
                        />
                    </div>
                    <br></br>
                    <div style={{ display: 'flex', marginLeft: alignMargin }}>
                        {mTbName === "T_BTLOAD" ? 
                          <span style={{ fontSize: '15px' }}>Note: Invoice, Bill issued after recog date will be recognized on </span>
                        : <span style={{ fontSize: '15px' }}>Note: Invoice, Bill, CrDb issued after recog date will be recognized on </span>
                        }
                    </div>
                    <div style={{ display: 'flex', marginLeft: alignMargin }}>
                        {mTbName === "T_BTLOAD" ? 
                          <span style={{ fontSize: '15px' }}>each date of Invoice, Bill issued respectively.</span>
                        : <span style={{ fontSize: '15px' }}>each date of Invoice, Bill, CrDb issued respectively.</span>
                        }
                    </div>
                </div>
                :
                <div>
                    <div>
                        <img src={NoticeWarningIcon} style={{ height: 32, width: 32, marginRight:'10px' }} alt="" />
                        <span>Do you want to Undo Recog ?</span>
                    </div>
                    <ButtonGroup
                        customClass="ifms-dialog-button ifms-dialog-button-yesorno"
                        buttons={['Yes', 'No']}
                        onButton={b => {
                            if (b === 'Yes') recognize();
                            else onCancel();
                        }}
                        defaultFocusIndex={0}
                        addOr={true}
                    />
                </div>
            }
        </Modal>
    )
}

export default React.memo(RecogModal);